import { render } from "./RegisterWithGooglePage.vue?vue&type=template&id=7ce0fad0&scoped=true"
import script from "./RegisterWithGooglePage.vue?vue&type=script&lang=js"
export * from "./RegisterWithGooglePage.vue?vue&type=script&lang=js"

import "./RegisterWithGooglePage.vue?vue&type=style&index=0&id=7ce0fad0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce0fad0"]])

export default __exports__